'use strict';

var pseudoStyle = require('./pseudo-style');
module.exports = pseudoStyle('focus')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/focus.js
// module id = 377
// module chunks = 168707334958949